import DamageEntryTabIcon from '@/common/assets/icons/damageEntryTab.svg?react';
import CardButton from '@/common/components/cardButton/CardButton';
import useModal from '@/common/hooks/useModal';
import { Box } from 'styled-system/jsx';
import DamagesInformationModal from '@/modules/FileDetail/components/fileInformation/modals/DamagesInformationModal/DamagesInformationModal.tsx';
import { DamagesInformationCardProps } from '@/modules/FileDetail/components/fileInformation/entryTabs/DamagesInformationCard/DamagesInformationCard.types.ts';

const DamagesInformationCard = ({ title }: DamagesInformationCardProps) => {
  const { open, openModal, closeModal } = useModal();

  const renderIcon = () => {
    return <DamageEntryTabIcon />;
  };

  return (
    <>
      <Box onClick={openModal} mb="16px">
        <CardButton hasArrow renderIcon={renderIcon} title={title} />
      </Box>
      <DamagesInformationModal closeModal={closeModal} open={open} />
    </>
  );
};
export default DamagesInformationCard;
